import React, { createContext, useState, useContext, useEffect } from "react";

// Create the context
const GlobalContext = createContext();

// Create a provider component
export const GlobalProvider = ({ children }) => {
  const [showModal, setShowModal] = useState(false);
  const [showModal1, setShowModal1] = useState(false);
  const [formSource, setFormSource] = useState("NAA");

  // Function to update the state
  // const updateModalState = (newValue) => {
  //   setShowModal(newValue);
  // };
  //
  useEffect(() => {
    setTimeout(() => {
      if (!showModal) {
        handleShowModal1();
      }
    }, 7000);
  }, []);
  const handleShowModal = (source) => {
    setFormSource(source);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setFormSource("NAA");
  };

  const handleShowModal1 = () => setShowModal1(true);
  const handleCloseModal1 = () => setShowModal1(false);

  return (
    <GlobalContext.Provider
      value={{
        showModal,
        handleShowModal,
        handleCloseModal,
        handleShowModal1,
        handleCloseModal1,
        showModal1,
        formSource,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

// Custom hook for using the Global Context
export const useGlobalContext = () => {
  return useContext(GlobalContext);
};
